// Redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { registerReducer } from '@eig-builder/core-utils/reducer-registry'
import { resetXsrfToken } from '@eig-builder/core-utils/fetch'
import { listenToFetchActions } from '@eig-builder/core-utils/helpers/reducer-helper'
import { getRuntimeConfig } from '@eig-builder/core-utils/helpers/runtime-config-helper'

import Component from './component'

import get from 'lodash/get'

import { GET_TOKEN_VALIDATE, GET_REFRESH_TOKEN, RESET_XSRF_TOKEN } from './action-types'

import { getTokenValidate } from './actions'

const reducer = (state = { retrieving: true }, action) => {
  if (action.type === RESET_XSRF_TOKEN) {
    return {
      ...state,
      xsrfToken: undefined
    }
  }

  const xsrftokenName = getRuntimeConfig()._fetchXsrfTokenHeaderName || 'X-XSRF-TOKEN'

  return (
    listenToFetchActions(state, action, GET_TOKEN_VALIDATE, {
      response: function (actionBody, newState, responseAction) {
        newState.retrieving = false
        newState.isAuthenticated = true
        newState.accountId = get(actionBody, 'accountId')
        newState.userFullName = get(actionBody, 'name')
        newState.userEmail = get(actionBody, 'email')
        newState.roles = get(actionBody, 'roles')
        newState.xsrfToken = responseAction.response.headers.get(xsrftokenName)
        newState.hasUserIdentifiedXSRFToken = true
        resetXsrfToken()
      },
      error: function (actionBody, newState) {
        newState.retrieving = false
        newState.xsrfToken = undefined
        newState.challengeRecaptcha = !!get(actionBody, 'challenge')
        resetXsrfToken()
      }
    }) ||
    listenToFetchActions(state, action, GET_REFRESH_TOKEN, {
      response: function (__, newState, responseAction) {
        newState.xsrfToken = responseAction.response.headers.get(xsrftokenName)
        resetXsrfToken()
      }
    }) ||
    state
  )
}

const mapStateToProps = ({ auth }) => {
  return {
    retrieving: auth.retrieving
  }
}

const mapDispatch = dispatch => {
  return {
    getTokenValidate: bindActionCreators(getTokenValidate, dispatch)
  }
}

const AuthenticationContainer = connect(
  mapStateToProps,
  mapDispatch
)(Component)

registerReducer('auth', reducer)

export { AuthenticationContainer }
